'use client';

import { Box, HStack, Button } from '@chakra-ui/react';
import { Link } from '@chakra-ui/next-js';
import { usePathname } from 'next/navigation';
import useNavbar from '~/hooks/useNavbar';
import { ICONS } from '~/constants';
import { Loader } from '~/components/ui/Loader';
import { HeaderAlert } from '~/components/ui/alerts/HeaderAlert';
import { RiMegaphoneFill } from 'react-icons/ri';
import { useAgency } from '~/hooks/useAgency';
import { useUser } from '~/hooks/useUser';
import { UserAvatar } from '../desktop/UserAvatar';
import { ROUTES } from '@habity/constants';
import { useUIStore } from '~/store';
import { useTranslations } from 'next-intl';
import { usePathUtils } from '~/hooks/usePathUtils';
import { Logo } from '../Logo';
import { getSellPath } from '@habity/services';

export function MobileHeader() {
  const { rootProps } = useNavbar();
  const pathname = usePathname();
  const { user, isUserLoaded } = useUser();
  const { agency } = useAgency();
  const {
    show: showAlerts,
    title_mobile: alertTitle,
    cta: alertCta,
    url: alertUrl,
  } = agency?.settings?.alerts?.header || {};
  const modals = useUIStore((state) => state.modals);
  const openLoginModal = useUIStore((state) => state.openLoginModal);
  const t = useTranslations('Header');
  const { isExactPath } = usePathUtils();

  // FIXME: This is duplicated between desktop and mobile header
  const isHeaderWhite =
    isExactPath(ROUTES.ROOT) ||
    isExactPath(ROUTES.SEARCH.HOMES) ||
    isExactPath(ROUTES.SEARCH.SPECULATORS) ||
    isExactPath(ROUTES.SEARCH.BROKERS) ||
    isExactPath(ROUTES.SEARCH.AREAS) ||
    isExactPath(ROUTES.SEARCH.MUNICIPALITIES) ||
    isExactPath(ROUTES.SEARCH.PLACES) ||
    isExactPath(ROUTES.SEARCH.PROJECTS) ||
    isExactPath(ROUTES.DASHBOARD.BUYER.INDEX) ||
    isExactPath(ROUTES.DASHBOARD.ACCOUNT) ||
    isExactPath(ROUTES.CMS.HOW_IT_WORKS) ||
    isExactPath(ROUTES.CMS.FAQ);

  if (!pathname) return <Loader />;

  return (
    <>
      {showAlerts && (
        <HeaderAlert
          icon={RiMegaphoneFill}
          title={alertTitle}
          description=""
          isLoading={false}
          cta={alertCta}
          onClick={() => window.open(alertUrl, '_blank')}
        />
      )}

      <Box
        as="nav"
        role="navigation"
        backgroundColor={isHeaderWhite ? 'white' : 'palePeach'}
        position="fixed"
        top="0"
        w="100vw"
        h="60px"
        zIndex="overlay"
        boxShadow="sm"
        {...rootProps}
      >
        <HStack
          spacing="8px"
          justify="space-between"
          align="center"
          py={{ mobile: '3', desktop: '4' }}
          px={{ mobile: '4', desktop: '16' }}
        >
          {/* Left: Logo */}
          <Logo />

          {/* Right: Links and menu */}
          <HStack spacing={0}>
            <Link href={getSellPath(undefined, 'estimate')}>
              <Button
                variant="subtle"
                leftIcon={<ICONS.SELL />}
                fontSize="sm"
                fontWeight="medium"
                px={3}
              >
                Värdera
              </Button>
            </Link>

            {user ? (
              <Link href={ROUTES.DASHBOARD.ACCOUNT}>
                <UserAvatar />
              </Link>
            ) : isUserLoaded ? (
              <Button
                onClick={() => openLoginModal()}
                variant="secondary"
                isActive={pathname === ROUTES.LOGIN || modals.loginOpen}
                fontSize="sm"
                px={4}
              >
                {t('Links.login')}
              </Button>
            ) : null}
          </HStack>
        </HStack>
      </Box>
    </>
  );
}
